import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Form, Grid, Header } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Input from '../Inputs/Input'
import Select from '../Inputs/Select'
import { FromTo, Normal, YesNo } from '../../../utils/FormSelectHelper'
import TextArea from '../Inputs/TextArea'
import { observer } from 'mobx-react'

@observer
class RIGBFN000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  render () {
    const { equipment } = this.props
    return (
      <>
        <Form>
          <Section title={(<Header as='h2'>A- INFORMATIONS</Header>)}>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column className='compact'>
                  <Form.Group widths='equal'>
                    <Select name='infoBorne' options={FromTo(1, 50)} formEntry={equipment} label='Borne' />
                    <Input name='infoSituee' formEntry={equipment} label='Située' />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Select
                      name='infoMarque' formEntry={equipment} options={[
                        { value: 'brid', text: 'Brigadier McAvity' },
                        { value: 'pre', text: 'Premier Concord' },
                        { value: 'autre', text: 'Autres' }
                      ]} label='Marque'
                    />
                    <Select name='infoElevationBrides' formEntry={equipment} options={FromTo(0, 20)} label='Élévation des brides' />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Select
                      name='infoModele' formEntry={equipment} options={[
                        { value: 'd67m', text: 'D67M' },
                        { value: 'm67', text: 'M67' },
                        { value: 'autre', text: 'Autres' }
                      ]} label='Modèle'
                    />
                    <Select
                      name='infoNiveauEau' formEntry={equipment} options={[
                        ...FromTo(0, 150),
                        { value: 'nul', text: 'Nul' },
                        { value: 'plein', text: 'Plein' }
                      ]} label="Niveau d'eau"
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Select
                      name='infoOuverture' formEntry={equipment} options={[
                        { value: '5', text: '5"' },
                        { value: '514', text: '5"1/4\'' },
                        { value: 'autre', text: 'Autres' }
                      ]} label='Ouverture'
                    />
                    <Select
                      name='infoQualiteDrainage' formEntry={equipment} options={[
                        { value: 'bon', text: 'Bon' },
                        { value: 'nul', text: 'Nul' }
                      ]} label='Qualité de Drainage'
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Select name='boiteVannePieds' formEntry={equipment} options={FromTo(1, 20)} label='Boîte de vanne située' />
                    <Select
                      name='boiteVannedirection' formEntry={equipment} options={[
                        { value: 'face', text: 'Face' },
                        { value: 'gauche', text: 'Gauche' },
                        { value: 'droite', text: 'Droite' },
                        { value: 'derriere', text: 'Derrière' }
                      ]} label='Direction'
                    />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Select
                      name='boiteVanneCondition' formEntry={equipment} options={[
                        { value: 'adequat', text: 'Adéquat' },
                        { value: 'desaxe', text: 'Désaxé' },
                        { value: 'autre', text: 'Autres' }
                      ]} label='Alignement boîte de vanne'
                    />
                    <div className='field' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Grid>
                    <Grid.Row columns={4}>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='right'>Nbr de prise d’eau</Header>
                      </Grid.Column>
                      <Grid.Column className='compact'>
                        <Select name='infoNbPriseEau1' options={FromTo(1, 4)} formEntry={equipment} />
                      </Grid.Column>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='center'>X</Header>
                      </Grid.Column>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='center'>2 1/2</Header>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4}>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='right'>Nbr de prise d’eau</Header>
                      </Grid.Column>
                      <Grid.Column className='compact'>
                        <Select name='infoNbPriseEau3' options={FromTo(1, 4)} formEntry={equipment} />
                      </Grid.Column>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='center'>X</Header>
                      </Grid.Column>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='center'>4" STORZ</Header>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4}>
                      <Grid.Column className='compact' verticalAlign='middle'>
                        <Header as='h5' textAlign='right'>Profondeur du poteau incendie</Header>
                      </Grid.Column>
                      <Grid.Column className='compact'>
                        <Select name='profondeurPoteauIncendiePied' options={FromTo(50, 144)} formEntry={equipment} />
                      </Grid.Column>
                      <Grid.Column className='compact' verticalAlign='middle' />
                      <Grid.Column className='compact' verticalAlign='middle' />
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>B- ÉTAT GÉNÉRAL</Header>)}>
            <Form.Group widths='equal'>
              <Select name='etatVisGraisseur' formEntry={equipment} options={Normal()} label='Vis de graisseur' />
              <Select name='etatTigeSuperieur' formEntry={equipment} options={Normal()} label='Tige supérieur' />
              <Select name='etatPurgeur' formEntry={equipment} options={Normal()} label='Purgeur' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='etatEcrousManoeurvre' formEntry={equipment} options={Normal()} label='Ecrous de manoeuvre' />
              <Select name='etatCarter' formEntry={equipment} options={Normal()} label='Carter' />
              <Select name='etatSiegeRobinetPrincipal' formEntry={equipment} options={Normal()} label='Siège robinet principal' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='etatJointEtancheite' formEntry={equipment} options={Normal()} label='Joint étanchéité' />
              <Select name='etatBrideSurete' formEntry={equipment} options={Normal()} label='Bride de sûreté' />
              <Select name='statCaoutchoucVannePrincipal' formEntry={equipment} options={Normal()} label='Caoutchouc vanne principal' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='etatBouchonChaineCable' formEntry={equipment} options={Normal()} label='Bouchon, chaîne, câble' />
              <Select name='etatCorps' formEntry={equipment} options={Normal()} label='Corps' />
              <Select name='etatAutre' formEntry={equipment} options={Normal()} label='Autre' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>C- LECTURE DES PRESSIONS</Header>)} secondaryField={(<Select name='lecturePressionOuiNon' formEntry={equipment} options={YesNo()} />)}>
            <Form.Group widths='equal'>
              <Select name='lecturePressionPressionStatique' formEntry={equipment} options={FromTo(0, 150)} label='Pression statique (lbs/PO2)' />
              <Select name='lecturePressionPressionStatique' formEntry={equipment} options={FromTo(0, 150)} label='Pression dynamique (lbs/PO2)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='lecturePressionDebitReel' formEntry={equipment} label='Débit réel (GPM)' />
              <Input name='lecturePressionHeure' formEntry={equipment} label='Heure' type='time' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>D- ANOMALIES</Header>)}>
            <TextArea name='anomalieAnomalie' label='Anomalie' formEntry={equipment} rows={10} />
          </Section>
          <Section title={(<Header as='h2'>E- REMARQUES</Header>)}>
            <TextArea name='remarquesRemarques' label='Remarques' formEntry={equipment} rows={10} />
          </Section>
        </Form>
      </>
    )
  }
}

export default RIGBFN000
